module.exports = __webpack_public_path__ + "static/img/info_1.4367435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/info_1.png
// module id = 7Nkm
// module chunks = 1